export default {
  langList: window._langListData || [],
  tg: {
    en_US: "https://t.me/VOOXEnglish",
    zh_CN: "https://t.me/VOOXChinese",
    zh_TW: "https://t.me/VOOXChinese",
    vi_VN: "https://t.me/VOOXVietnam",
    ru_RU: "https://t.me/VOOXRussiangroup",
    ja_JP: "https://t.me/voox_japan",
  },
  x: {
    en_US: "https://x.com/VOOX_Global",
    zh_CN: "https://x.com/VOOX_ZH",
    zh_TW: "https://x.com/VOOX_ZH",
    zh_TC: "https://x.com/VOOX_ZH",
    zh_TW: "https://x.com/VOOX_ZH",
  },
  seo: {
    zh_CN: {
      "/": {
        title: "VOOX｜最懂你的AI智能交易平台",
        description:
          "VOOX 是全球领先的加密货币交易平台，您可以放心购买比特币、以太币、狗狗币、瑞波币等数字货币",
        keywords:
          "加密货币交易所，区块链加密货币，比特币交易，现货交易，永续合约交易，合约赠金，合约跟单，BTC，ETH",
      },
    },
    en_US: {
      "/": {
        title: "VOOX | The AI-Driven Exchange that knows you best",
        description:
          "VOOX is a top crypto exchange where you can buy BTC, Eth, Dogecoin, Ripple, and more.",
        keywords:
          "Crypto Exchange, Blockchain, BTC Trading, Spot Trading, Perpetual futures, Futures Bonuses, Copy Trading,BTC,ETH",
      },
    },
    el_GR: {
      "/": {
        title: "VOOX｜最懂你的AI智能交易平台",
        description:
          "VOOX 是全球領先的加密貨幣交易平台，您可以放心購買比特幣、以太幣、狗狗幣、瑞波幣等數位貨幣",
        keywords:
          "加密貨幣交易所，區塊鏈加密貨幣，比特幣交易，現貨交易，永續合約交易，合約贈金，合約跟單、BTC、ETH",
      },
    },
    zh_TC: {
      "/": {
        title: "VOOX｜最懂你的AI智能交易平台",
        description:
          "VOOX 是全球領先的加密貨幣交易平台，您可以放心購買比特幣、以太幣、狗狗幣、瑞波幣等數位貨幣",
        keywords:
          "加密貨幣交易所，區塊鏈加密貨幣，比特幣交易，現貨交易，永續合約交易，合約贈金，合約跟單、BTC、ETH",
      },
    },
    zh_TW: {
      "/": {
        title: "VOOX｜最懂你的AI智能交易平台",
        description:
          "VOOX 是全球領先的加密貨幣交易平台，您可以放心購買比特幣、以太幣、狗狗幣、瑞波幣等數位貨幣",
        keywords:
          "加密貨幣交易所，區塊鏈加密貨幣，比特幣交易，現貨交易，永續合約交易，合約贈金，合約跟單、BTC、ETH",
      },
    },
  },
};
